var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAgeRating0 = function SvgAgeRating0(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2497 0C19.7686 0 21 1.23137 21 2.75034V18.2497C21 19.7686 19.7686 21 18.2497 21H2.75034C1.23137 21 0 19.7686 0 18.2497V2.75034C0 1.23137 1.23137 0 2.75034 0H18.2497Z",
    fill: "#6FB858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.60494 7.30655C8.60494 8.30429 7.72153 9.11311 6.63179 9.11311C5.54205 9.11311 4.65864 8.30429 4.65864 7.30655C4.65864 6.30882 5.54205 5.5 6.63179 5.5C7.72153 5.5 8.60494 6.30882 8.60494 7.30655ZM16.3393 7.30655C16.3393 8.30429 15.4559 9.11311 14.3661 9.11311C13.2764 9.11311 12.393 8.30429 12.393 7.30655C12.393 6.30882 13.2764 5.5 14.3661 5.5C15.4559 5.5 16.3393 6.30882 16.3393 7.30655ZM10.4937 12.9298C6.01278 12.9298 3.5 11.0745 3.5 11.0745C3.5 11.0745 4.23621 15.5 10.5 15.5C16.7638 15.5 17.5 11.0745 17.5 11.0745C17.5 11.0745 14.9746 12.9298 10.4937 12.9298Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAgeRating0, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/age_rating_0.29e999eb.svg";
export { ForwardRef as ReactComponent };